var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "schedule"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_253_3017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.61792,
    y: 0.947754,
    width: 14,
    height: 14,
    fill: "#676F83"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_253_3017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "schedule_2",
    d: "M9.543 10.6893L10.3597 9.87259L8.20133 7.71426V5.03092H7.03467V8.18093L9.543 10.6893ZM7.618 13.7809C6.81106 13.7809 6.05272 13.6278 5.343 13.3216C4.63328 13.0153 4.01592 12.5997 3.49092 12.0747C2.96592 11.5497 2.55029 10.9323 2.24404 10.2226C1.93779 9.51287 1.78467 8.75454 1.78467 7.94759C1.78467 7.14065 1.93779 6.38231 2.24404 5.67259C2.55029 4.96287 2.96592 4.34551 3.49092 3.82051C4.01592 3.29551 4.63328 2.87988 5.343 2.57363C6.05272 2.26738 6.81106 2.11426 7.618 2.11426C8.42495 2.11426 9.18328 2.26738 9.893 2.57363C10.6027 2.87988 11.2201 3.29551 11.7451 3.82051C12.2701 4.34551 12.6857 4.96287 12.992 5.67259C13.2982 6.38231 13.4513 7.14065 13.4513 7.94759C13.4513 8.75454 13.2982 9.51287 12.992 10.2226C12.6857 10.9323 12.2701 11.5497 11.7451 12.0747C11.2201 12.5997 10.6027 13.0153 9.893 13.3216C9.18328 13.6278 8.42495 13.7809 7.618 13.7809ZM7.618 12.6143C8.91106 12.6143 10.0121 12.1597 10.9211 11.2507C11.8302 10.3417 12.2847 9.24065 12.2847 7.94759C12.2847 6.65454 11.8302 5.55349 10.9211 4.64447C10.0121 3.73544 8.91106 3.28092 7.618 3.28092C6.32495 3.28092 5.2239 3.73544 4.31488 4.64447C3.40585 5.55349 2.95133 6.65454 2.95133 7.94759C2.95133 9.24065 3.40585 10.3417 4.31488 11.2507C5.2239 12.1597 6.32495 12.6143 7.618 12.6143Z",
    fill: "#676F83"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.15f579f1e52aa14b18477a31664b8d1c.svg";
export { ForwardRef as ReactComponent };